var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useCallback } from 'react';
import _ from 'lodash';
import classnames from 'classnames/bind';
import FilterDropdown from '../../FilterDropdown';
import FilterResult from '../../FilterResult';
import style from './index.module.scss';
import instance from '../../../services/httpRequest';
import Loading from '../../Loading';
import localesReplacement from '../../../utils/localesReplacement';
import UsStates from '../../../utils/states';
import AusStates from '../../../utils/ausStates';
import UkCountries from '../../../utils/ukCountries';
import { useDebounce } from 'use-debounce';
import { GoogleReCaptchaProvider, GoogleReCaptcha } from 'react-google-recaptcha-v3';
import { ENABLED_LICENSE_PLATE_COUNTRIES } from '../../../constants';
var cx = classnames.bind(style);
function LicensePlateSearch(props) {
    var onVehicleSelect = props.onVehicleSelect, replacements = props.replacements, selectedWorkshop = props.selectedWorkshop, country = props.country, captcha = props.captcha, language = props.language;
    var _a = useState([]), states = _a[0], setStates = _a[1];
    var _b = useState(''), state = _b[0], setState = _b[1];
    var _c = useState(''), licensePlate = _c[0], setLicensePlate = _c[1];
    var _d = useState([]), results = _d[0], setResults = _d[1];
    var _e = useState(false), isMount = _e[0], setIsMount = _e[1];
    var _f = useState(false), finish = _f[0], setFinish = _f[1];
    var debounceValue = useDebounce(licensePlate, 1000)[0];
    var _g = useState(''), reCaptchaToken = _g[0], setRecaptchaToken = _g[1];
    var _h = useState(false), refreshReCaptcha = _h[0], setRefreshReCaptcha = _h[1];
    useEffect(function () {
        setLicensePlate(_.toString(debounceValue));
    }, [debounceValue]);
    var onVerify = useCallback(function (token) {
        setRecaptchaToken(token);
    }, []);
    //Get list of US States
    useEffect(function () {
        switch (country) {
            case 'UAS':
                setStates(UsStates);
                break;
            case 'AUS':
                setStates(AusStates);
                break;
            case 'GBR':
                setStates(UkCountries);
                break;
            default:
                setStates(UsStates);
                break;
        }
    }, [country]);
    // Search  by license plate
    useEffect(function () {
        var _a;
        if (!!(state || !ENABLED_LICENSE_PLATE_COUNTRIES.includes(country || '')) && _.trim(licensePlate).length >= 3) {
            setFinish(false);
            setIsMount(true);
            if (captcha) {
                if (!reCaptchaToken) {
                    setResults([]);
                    return;
                }
                _.assign(instance.defaults.headers, {
                    Authorization: "Captcha ".concat(reCaptchaToken),
                });
            }
            else {
                _.unset(instance.defaults.headers, 'Authorization');
            }
            instance
                .get("/usaLicensePlateSearch?text=".concat(licensePlate, "&stateCode=").concat(((_a = states.find(function (x) { return x.name === state; })) === null || _a === void 0 ? void 0 : _a.id) || 'STA'))
                .then(function (d) {
                if (_.inRange(d.status, 200, 300)) {
                    setResults(d.data);
                }
                else {
                    setResults([]);
                }
                setIsMount(false);
                setFinish(true);
                setRefreshReCaptcha(true);
            });
        }
        else {
            setFinish(false);
            setResults([]);
        }
    }, [state, debounceValue, selectedWorkshop]);
    var onChangeHandler = function (value) {
        setLicensePlate(value);
    };
    var onClearHandler = function () {
        setLicensePlate('');
    };
    /* State dropdown change */
    // eslint-disable-next-line
    var changeState = function (stateCode) {
        setState(stateCode);
    };
    var renderResults = function () {
        return !_.isEmpty(results) ? (_jsx(_Fragment, { children: _jsx(FilterResult, { dataList: results, sort: true, value: licensePlate, onSelect: onVehicleSelect, replacements: replacements }, void 0) }, void 0)) : (finish &&
            _.trim(licensePlate).length >= 3 && (_jsx("div", __assign({ className: 'no-match' }, { children: _jsx("div", __assign({ className: 'no-found-text no-oil-text' }, { children: _jsxs("p", { children: [localesReplacement(replacements, 'No results found for'), _jsx("strong", { children: _.trim(licensePlate) }, void 0)] }, void 0) }), void 0) }), void 0)));
    };
    var inputClassName = ENABLED_LICENSE_PLATE_COUNTRIES.includes(country || '') ? "".concat(cx('search-input')) : "".concat(cx('search-input'), " ").concat(cx('fluid'));
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: cx('dropdown-list') }, { children: [ENABLED_LICENSE_PLATE_COUNTRIES.includes(country || '') && (_jsx("div", __assign({ className: cx('dropdown-item') }, { children: _jsx(FilterDropdown, { dataList: states, filter: state, changeHandler: changeState, type: country === 'GBR' ? localesReplacement(replacements, 'Country') : localesReplacement(replacements, 'State'), replacements: replacements }, void 0) }), void 0)), _jsxs("div", __assign({ className: inputClassName }, { children: [captcha && (_jsxs(_Fragment, { children: [_jsx("div", { id: "captcha-container", className: cx('recaptcha-container') }, void 0), _jsx(GoogleReCaptchaProvider, __assign({ reCaptchaKey: "6Ld2oX4UAAAAACqWA9-3ostCypVeQRd4JPIT6dZR", language: language === null || language === void 0 ? void 0 : language.slice(0, -1).toLowerCase(), useRecaptchaNet: false, useEnterprise: false, scriptProps: {
                                            async: false,
                                            defer: false,
                                            appendTo: 'head',
                                            nonce: undefined // optional, default undefined
                                        }, container: {
                                            element: "captcha-container",
                                            parameters: {
                                                badge: 'inline',
                                                theme: 'dark', // optional, default undefined
                                            }
                                        } }, { children: _jsx(GoogleReCaptcha, { onVerify: onVerify, refreshReCaptcha: refreshReCaptcha }, void 0) }), void 0)] }, void 0)), _jsx("input", { type: 'text', value: licensePlate, onChange: function (ev) { return onChangeHandler(ev.target.value); }, placeholder: localesReplacement(replacements, 'Enter license plate'), maxLength: 36 }, void 0), !!licensePlate.length && (_jsx("i", { className: cx('remove'), onClick: onClearHandler }, void 0)), _jsx("i", { className: cx('voice') }, void 0)] }), void 0)] }), void 0), !isMount ? (renderResults()) : (_jsx(Loading, {}, void 0))] }, void 0));
}
export default LicensePlateSearch;
